import { Link } from "react-router-dom";
import { siteStats } from "@/mocks/site";

export default function Hero() {
  return (
    <section className="relative w-full min-h-[540px] md:min-h-[640px] flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Cinematic%20warm%20toned%20abstract%20illustration%20of%20a%20crowded%20night%20scene%20with%20glowing%20amber%20and%20coral%20bokeh%20lights%2C%20soft%20haze%2C%20deep%20shadows%2C%20editorial%20magazine%20cover%20style%2C%20high%20contrast%20for%20text%20overlay%2C%20no%20recognizable%20faces&width=1600&height=900&seq=bl91-hero-crowd&orientation=landscape"
        alt="夜晚热闹的讨论现场抽象插画背景"
        title="爆料91 热议话题 吃瓜现场"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/35 to-black/65"></div>

      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12 py-16 md:py-24">
        <div className="max-w-3xl animate-fade-up">
          <span className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-background-50/15 backdrop-blur border border-background-50/25 text-background-50 text-xs md:text-sm font-medium">
            <span className="w-2 h-2 rounded-full bg-accent-400 animate-pulse"></span>
            热门讨论实时滚动 · 24 小时更新
          </span>

          <h1 className="mt-6 text-3xl md:text-5xl lg:text-[56px] font-black leading-tight text-white font-heading">
            爆料91
            <span className="block mt-2 text-2xl md:text-4xl lg:text-[40px] text-accent-400">
              吃瓜现场之外的讨论，都在这
            </span>
          </h1>

          <p className="mt-6 text-sm md:text-base leading-relaxed text-white/85 max-w-2xl">
            评论区里大家怎么接茬、舆论反应如何分化，我们把散落各处的
            <strong className="font-bold text-white">热议话题</strong>、
            <strong className="font-bold text-white">网友讨论</strong>与
            <strong className="font-bold text-white">观点对照</strong>
            整理成可读的话题卡片。不用翻半天评论区，一眼就能看懂大家在聊什么。
          </p>

          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            <Link
              to="/topics"
              className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-full bg-primary-500 text-background-50 text-sm md:text-base font-bold whitespace-nowrap hover:bg-primary-600 transition-colors"
            >
              <i className="ri-fire-line text-lg"></i>
              浏览热议话题
            </Link>
            <Link
              to="/submit"
              className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-full bg-background-50/12 backdrop-blur border border-background-50/35 text-background-50 text-sm md:text-base font-bold whitespace-nowrap hover:bg-background-50/20 transition-colors"
            >
              <i className="ri-send-plane-line text-lg"></i>
              我有线索要投稿
            </Link>
          </div>
        </div>

        <dl className="mt-12 md:mt-16 grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-5 animate-fade-up">
          {siteStats.map((stat) => (
            <div
              key={stat.label}
              className="rounded-2xl bg-background-50/10 backdrop-blur border border-background-50/15 px-4 md:px-5 py-4"
            >
              <dt className="text-xl md:text-2xl font-black text-accent-400">{stat.value}</dt>
              <dd className="mt-1 text-xs md:text-sm text-white/75">{stat.label}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}